import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  Logo,
  Nav,
  IconsMobile,
  UserIcon,
  UserIconContainer,
  LogoContainer,
} from "./NavbarElements";

// import MenuIcon from "../../components/MenuIcon";
import MenuIcon2 from "./MenuIcon2";
import {
  selectLoginModal,
  selectRegisterModal,
  selectDepositModal,
  selectWithdrawModal,
  setShowUserRegisterModal,
  setShowUserLoginModal,
  setShowUserDepositModal,
  setShowUserWithdrawModal,
  selectShowUserMenuMobile,
  setShowUserMenuMobile,
  setUrlverify,
  setShowJumio,
} from "../../features/modals/modalsSlice";
import {
  selectLogged,
  setActivePage,
  selectId,
  selectToken,
  selectCurrency,
  selectFoto,
  selectNotVerifiedPeru,
  selectBlockRetiro,
} from "../../features/user/userSlice";
import NavSectionComp from "./NavSectionComp";
import { selectHayNotificaciones } from "../../features/notifications/notificationsSlide";
import logo from "../../assets/images/logos/mb_mobile.svg";
import logomovil from "../../assets/images/logomovil.svg";
import UserResumeProfile2 from "./UserResumeProfile2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { selectLimites, setLimites } from "../../features/limitaciones/limitacionesSlice";
import { errorNotification, infoNotification } from "../../utils/toastNotifications";
import axios from "axios";
import { API_URL } from "../../const/api";
import { comprobarTiempoInactivo } from "../../utils/tools";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import SwalBlockRetiro from "../../components/SwalBlockRetiro";

const NavComp2 = ({ saldoTotal, clicked, setClicked }) => {
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const isLoged = useSelector(selectLogged);
  const registerModal = useSelector(selectRegisterModal);
  const loginModal = useSelector(selectLoginModal);
  const depositModal = useSelector(selectDepositModal);
  const showUserMenuMobile = useSelector(selectShowUserMenuMobile);
  const hayNotificaciones = useSelector(selectHayNotificaciones);
  const fotoPerfil = useSelector(selectFoto);
  const dispatch = useDispatch();
  const urlImage = "https://notificaciones.betsfactory.co/img_pp/";
  const limitaciones = useSelector(selectLimites);
  const [showingNotificacion, setShowingNotification] = useState(false);
  const navigate = useNavigate();
  const [t] = useTranslation("global");
  const blockRetiro = useSelector(selectBlockRetiro)

  const notVerifiedPeru = useSelector(selectNotVerifiedPeru);

  const getLimitaciones = async () => {
    let body = { id_uo, token };
    let tiempo_inactivo = ''
    try {
      const res = await axios.post(API_URL + "getLimitaciones", body);
      if (res.data.response !== null) {
        dispatch(setLimites(res.data.response));
        const fecha_config = res.data.response.fecha_config;
        tiempo_inactivo = res.data.response.tiempo_inactivo;

        //validamos si se cumplio el tiempo de inactividad
        if(tiempo_inactivo > 0 && fecha_config && comprobarTiempoInactivo(fecha_config)) {
          // se cumplio el tiempo de inactividad y lo seteamos a 0
          body = {...body, ...limitaciones, tiempo_inactivo: 0, fecha_config: null}
          const res = await axios.post(API_URL + "setLimitaciones", body);
          if(res.data.response==='ok') {
            dispatch(setLimites({...limitaciones, tiempo_inactivo: 0, fecha_config: null}))
          }
        } 
      } 
    } catch (error) {
      //console.log(error);
    }

    return tiempo_inactivo;
  };

  const verificacionJumio = async () => {
    let body = {
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "verify", body);
    if (res.data.code === 200) {
      dispatch(setUrlverify(res.data.response_data.web.href));
      dispatch(setShowJumio(true));
    } else {
      if (res.data.message) {
        errorNotification(res.data.message, "top-center");
      } else {
        errorNotification(t("alert.errorNotificationRetiro-66"), "top-center");
      }
    }
  }

  const handleModals = (name, value) => {
    if (name === "register") dispatch(setShowUserRegisterModal(value));
    if (name === "login") dispatch(setShowUserLoginModal(value));
    if (name === "deposit" && limitaciones.tiempo_inactivo<=0)
      dispatch(setShowUserDepositModal({ open: value, type: false }));
    if (name === "withdraw" && !blockRetiro)
      dispatch(setShowUserDepositModal({ open: value, type: true }));

    if((name==='deposit') && isLoged && value===true && limitaciones.tiempo_inactivo>0) {
      const tiempo = getLimitaciones();
      if(limitaciones.tiempo_inactivo>0) {
        infoNotification("Su cuenta se encuentra inactiva por indicaciones del usuario.")
      } 
    }

    if(name==='withdraw' && isLoged && value===true && blockRetiro) {
     // infoNotification("Su cuenta no se encuentra verificada y no puede realizar esta accion.")
      SwalBlockRetiro(verificacionJumio)
    }
  };

  const hideModals = (link) => {
    setClicked(false);
    dispatch(setShowUserMenuMobile(false));
    handleModals("register", false);
    handleModals("login", false);
    handleModals("deposit", false);
    handleModals("withdraw", false);
    getLimitaciones();
    
    if(link !=='withdraw'&&limitaciones.tiempo_inactivo>0) {
      infoNotification("Su cuenta se encuentra inactiva por indicaciones del usuario.")
    }

    /* if(notVerifiedPeru) {
      infoNotification("Su cuenta no se encuentra verificada y no puede realizar esta accion.")
    } */
    dispatch(setActivePage(link));
    const scrollmodal = document.getElementById("root");
    scrollmodal.scrollIntoView({ behavior: "smooth" });
  };
  const handleNavItems = (url) => {
    hideModals(url);
    if (
      (url === "header.link-2.url" || url === "header.link-6.url") &&
      !isLoged
    ) {
      dispatch(setShowUserLoginModal(true));
    }

    if(url==='header.link-4.url'&&window.location.pathname ===  t("header.link-4.url")) navigate(0);
    if(url==='header.link-3.url'&&window.location.pathname ===  t("header.link-3.url")) navigate(0);

    setTimeout(() => {
      const scrollmodal = document.getElementById("root");
      scrollmodal.scrollIntoView({ behavior: "smooth" });
    }, 2000);
  };
  const handleClick = () => {
    setClicked(!clicked);
    dispatch(setShowUserMenuMobile(false));
    handleModals("register", false);
    handleModals("login", false);
    handleModals("deposit", false);
    handleModals("withdraw", false);
  };

  const handleMenuUser = () => {
    !isLoged && (!loginModal ? handleModals("login", true) : handleClose());
    !isLoged && registerModal && handleModals("register", false);
    isLoged && depositModal && handleModals("deposit", false);
    isLoged && handleShowUserMenuMobile();
    setClicked(false);
  };

  const handleClose = () => dispatch(setShowUserLoginModal(false));

  const handleShowUserMenuMobile = () => {
    dispatch(setShowUserMenuMobile(!showUserMenuMobile));
  };

  const changeLogo = useMediaQuery("(min-width:500px)");

  return (
    <Nav className={isLoged ? "loged" : null}>
      <IconsMobile>
        <LogoContainer>
          <MenuIcon2 clicked={clicked} handleClick={handleClick} />
        </LogoContainer>
      </IconsMobile>

      {isLoged ? (
        <Link to="/" onClick={() => hideModals("/")}>
          {changeLogo ? (
            <Logo src={logo} />
          ) : (
            <Logo className="minilogo" src={logomovil} />
          )}
        </Link>
      ) : (
        <Link to="/" onClick={() => hideModals("/")}>
          <Logo src={logo} />
        </Link>
      )}
      <NavSectionComp
        saldoTotal={saldoTotal}
        clicked={clicked}
        setClicked={setClicked}
        handleModals={handleModals}
        handleNavItems={handleNavItems}
      />

      <IconsMobile>
        <UserIconContainer>
          {isLoged && hayNotificaciones && <span></span>}
        </UserIconContainer>

        {isLoged && <UserResumeProfile2 />}

        <UserIconContainer>
          {fotoPerfil ? (
            <img onClick={handleMenuUser} src={urlImage + fotoPerfil} alt="" />
          ) : (
            <UserIcon onClick={handleMenuUser} className="glow" />
          )}
        </UserIconContainer>
      </IconsMobile>
    </Nav>
  );
};

export default NavComp2;
